<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <div class="page-title">
                    <h2>{{ titleKey | translate }}</h2>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-9" *ngIf="loading" style="text-align: center;">
                {{'common.loading' | translate}} ...
            </div>
            
            <div class="col-md-9" *ngIf="!loading">
                <div class="subscription-container">
                    <!-- Header -->
                    <header class="pricing-header">
                        <p *ngIf="!hasActivePremium && !paymentConfirmed">{{'subscription.subtitle' | translate}}</p>
                    </header>

                    <!-- Active Premium Subscription Management / Pending eFarm MoMo confirmation -->
                    <div *ngIf="hasActivePremium || paymentConfirmed" class="subscription-management">

                        <!-- Pending approval notice (eFarm Mobile Money) -->
                        <div class="status-banner" *ngIf="paymentConfirmed">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-check-circle me-2"></i>
                                <span><strong>Payment confirmed.</strong> Your payment has been received and your subscription will be activated once it is approved.</span>
                            </div>
                        </div>

                        <!-- Status Banner -->
                        <div class="status-banner" *ngIf="hasActivePremium">
                            <div class="d-flex align-items-center">
                                <i class="fa fa-check-circle me-2"></i>
                                <span>You're on the <strong>{{ subscriptionData?.packageTitle }}</strong> plan — enjoy all features until {{ formatDate(subscriptionData?.endDate) }}</span>
                            </div>
                        </div>

                        <!-- Current Plan Card -->
                        <div class="management-card">
                            <div class="section-label">Current Plan</div>
                            <div class="plan-header">
                                <div class="plan-title">{{ subscriptionData?.packageTitle }}</div>
                                <div class="plan-price">{{ subscriptionData?.amount?.toLocaleString() }} XAF <span>/ month</span></div>
                            </div>
                            <div class="plan-badges">
                                <span class="badge-premium">Premium</span>
                                <span class="badge-active" *ngIf="!paymentConfirmed">Active</span>
                                <span class="badge-active" *ngIf="paymentConfirmed" style="background-color: #ffc107; color: #856404;">Awaiting approval</span>
                            </div>
                            <div class="plan-details">
                                <div class="detail-row">
                                    <span class="detail-label">Start date</span>
                                    <span class="detail-value">{{ formatDate(subscriptionData?.startDate) }}</span>
                                </div>
                                <div class="detail-row">
                                    <span class="detail-label">End date</span>
                                    <span class="detail-value">{{ formatDate(subscriptionData?.endDate) }}</span>
                                </div>
                                <div class="detail-row">
                                    <span class="detail-label">Days remaining</span>
                                    <span class="detail-value">{{ daysRemaining }} days</span>
                                </div>
                            </div>
                            <div class="progress-section">
                                <div class="progress-bar-container">
                                    <div class="progress-bar-fill" [style.width.%]="progressPercent"></div>
                                </div>
                                <div class="progress-labels">
                                    <span>{{ formatDate(subscriptionData?.startDate) }}</span>
                                    <span>{{ daysUsed }} days used</span>
                                    <span>{{ formatDate(subscriptionData?.endDate) }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- What's Included Card -->
                        <div class="management-card">
                            <div class="section-label">What's Included</div>
                            <div class="features-grid">
                                <div class="feature-item" *ngFor="let feature of premiumFeatures">
                                    <i class="fa fa-check-circle feature-check"></i>
                                    <span>{{ feature }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Tablet Card -->
                        <div class="management-card" *ngIf="subscriptionData?.tablet">
                            <div class="section-label">Tablet Included</div>
                            <div class="tablet-info">
                                <div class="tablet-image">
                                    <img src="assets/images/tablet.jpg" alt="eFarm.cm Tablet" style="width: 100%; max-width: 200px; border-radius: 8px;">
                                </div>
                                <div class="tablet-details">
                                    <div class="tablet-name">eFarm.cm Tablet</div>
                                    <div class="tablet-status">You have purchased an eFarm.cm Tablet</div>
                                    <div class="tablet-verified" *ngIf="subscriptionData?.seller?.status === 'VERIFIED'">
                                        <i class="fa fa-check-circle"></i> Verified
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Manage Subscription Card -->
                        <div class="management-card">
                            <div class="section-label">Manage Subscription</div>
                            <p class="renewal-text">Your subscription renews automatically on {{ formatDate(subscriptionData?.endDate) }}. You can cancel anytime before that date.</p>
                            <div class="action-buttons">
                                <button class="btn btn-billing" [routerLink]="['/user/billing-history']">Billing history</button>
                            </div>
                        </div>
                    </div>

                    <!-- Pricing Grid (shown when no active premium and no pending MoMo payment) -->
                    <div class="pricing-grid" *ngIf="!hasActivePremium && !paymentConfirmed">
                        
                        <!-- FREE Package -->
                        <div class="card"
                             [class.selected]="packages[0]?.selected"
                             [class.free-package]="true"
                             (click)="selectPackage(packages[0])"
                             style="cursor: pointer;">
                            <div class="card-title">{{packages[0]?.title}}</div>
                            <div class="card-price">
                                <span class="price-value">{{getFormattedPrice(packages[0]?.monthlyPrice)}}</span>
                            </div>
                            <div class="yearly-price">
                                <span>{{getFormattedPrice(packages[0]?.yearlyPrice)}}</span>
                                <span class="period">/{{'subscription.yearly' | translate}}</span>
                            </div>
                            <ul class="card-features">
                                <li *ngFor="let feature of packages[0]?.features">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                    </svg>
                                    {{feature}}
                                </li>
                            </ul>
                        </div>

                        <!-- PREMIUM Package -->
                        <div class="card featured"
                             [class.selected]="packages[1]?.selected"
                             [class.premium-package]="true"
                             (click)="selectPackage(packages[1])"
                             style="cursor: pointer;">
                            <span class="badge" *ngIf="!packages[1]?.selected">{{'subscription.recommended' | translate}}</span>
                            <div class="card-title">{{packages[1]?.title}}</div>

                            <!-- Billing Period Toggle -->
                            <div class="billing-toggle" (click)="$event.stopPropagation()">
                                <button class="toggle-btn"
                                        [class.active]="selectedPeriod === 'MONTHLY'"
                                        (click)="selectedPeriod = 'MONTHLY'">
                                    {{'subscription.monthly' | translate}}
                                </button>
                                <button class="toggle-btn"
                                        [class.active]="selectedPeriod === 'YEARLY'"
                                        (click)="selectedPeriod = 'YEARLY'">
                                    {{'subscription.yearly' | translate}}
                                </button>
                            </div>

                            <div class="card-price">
                                <span class="price-value">{{getFormattedPrice(getSubscriptionPrice(packages[1]))}}</span>
                                <span class="period">/{{selectedPeriod === 'MONTHLY' ? ('subscription.monthly' | translate) : ('subscription.yearly' | translate)}}</span>
                            </div>
                            <div class="yearly-price" *ngIf="selectedPeriod === 'YEARLY' && getYearlySavings(packages[1]) > 0">
                                <span class="savings-text">{{'subscription.save' | translate}} {{getFormattedPrice(getYearlySavings(packages[1]).toString())}} {{'subscription.with_yearly' | translate}}</span>
                            </div>
                            
                            <!-- Tablet Option -->
                            <div class="tablet-option" (click)="$event.stopPropagation()" *ngIf="packages[1]?.selected">
                                <div class="tablet-preview">
                                    <img src="assets/images/tablet.jpg" alt="eFarm.cm Tablet" class="tablet-image">
                                    <div class="tablet-info">
                                        <h4>eFarm.cm Tablet</h4>
                                        <p class="tablet-price">{{'subscription.tablet_price' | translate}}</p>
                                        <p class="tablet-note">{{'subscription.tablet_one_time' | translate}}</p>
                                    </div>
                                </div>
                                <div class="form-check mt-2">
                                    <input class="form-check-input" type="checkbox" id="includeTablet" [(ngModel)]="includeTablet">
                                    <label class="form-check-label" for="includeTablet">
                                        {{'subscription.add_tablet' | translate}}
                                    </label>
                                </div>
                            </div>

                            <!-- Payment Method Selection -->
                            <div class="payment-method" (click)="$event.stopPropagation()" *ngIf="packages[1]?.selected">
                                <label class="payment-label">{{'subscription.payment_method' | translate}}</label>
                                <select class="form-select" [(ngModel)]="selectedPaymentMethod">
                                    <option value="FLUTTERWAVE">{{'common.mobile_wallet' | translate}}</option>
                                    <option value="COMPANY_MOBILE_MONEY">{{'common.company_money' | translate}}</option>
                                </select>
                            </div>

                            <ul class="card-features">
                                <li *ngFor="let feature of packages[1]?.features">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                    </svg>
                                    {{feature}}
                                </li>
                            </ul>
                            <button class="btn btn-solid"
                                    *ngIf="packages[1]?.selected"
                                    [disabled]="processing"
                                    (click)="$event.stopPropagation(); openConfirmModal()">
                                <span *ngIf="!processing">{{'subscription.purchase_now' | translate}}</span>
                                <span *ngIf="processing">{{'common.loading' | translate}}...</span>
                            </button>
                        </div>

                    </div>
                </div>

                <!-- Confirmation Modal -->
                <div class="modal fade" [ngClass]="showConfirmModal ? 'show' : ''" style="display: block; background: rgba(51, 51, 51, .6);" *ngIf="showConfirmModal">
                    <div class="modal-dialog modal-dialog-centered">
                        <div class="modal-content">
                            <div class="modal-header" style="background: #0c812c; color: #fff;">
                                <h5 class="modal-title" style="font-weight: bold;">{{'subscription.confirm_purchase_title' | translate}}</h5>
                                <button class="btn-close btn-close-white" (click)="closeConfirmModal()"></button>
                            </div>
                            <div class="modal-body" style="padding: 24px;">
                                <div style="margin-bottom: 20px;">
                                    <div style="font-size: 1.1em; margin-bottom: 16px; color: #333;" [innerHTML]="'subscription.about_to_subscribe' | translate: {package: 'Premium'}">
                                    </div>
                                    
                                    <div style="background: #f8f9fa; border-radius: 8px; padding: 16px; margin-bottom: 16px;">
                                        <div style="font-weight: 600; margin-bottom: 12px; color: #495057; font-size: 0.85em; text-transform: uppercase;">{{'subscription.order_details' | translate}}</div>
                                        
                                        <div style="display: flex; justify-content: space-between; margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #e9ecef;">
                                            <span>{{'subscription.plan' | translate}}</span>
                                            <span style="font-weight: 500;">Premium ({{selectedPeriod === 'MONTHLY' ? ('subscription.monthly_period' | translate) : ('subscription.yearly_period' | translate)}})</span>
                                        </div>
                                        
                                        <div style="display: flex; justify-content: space-between; margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #e9ecef;">
                                            <span>{{'subscription.subscription_label' | translate}}</span>
                                            <span style="font-weight: 500;">{{getFormattedPrice(getSubscriptionPrice(selectedPackage))}}</span>
                                        </div>
                                        
                                        <div *ngIf="includeTablet" style="display: flex; justify-content: space-between; margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #e9ecef; color: #0c812c;">
                                            <span><i class="fa fa-tablet"></i> eFarm.cm Tablet</span>
                                            <span style="font-weight: 500;">+{{getFormattedPrice(TABLET_PRICE.toString())}}</span>
                                        </div>
                                        
                                        <div style="display: flex; justify-content: space-between; margin-bottom: 8px; padding-bottom: 8px; border-bottom: 1px solid #e9ecef;">
                                            <span>{{'subscription.payment_method_label' | translate}}</span>
                                            <span style="font-weight: 500;">{{selectedPaymentMethod === 'FLUTTERWAVE' ? ('common.mobile_wallet' | translate) : ('common.company_money' | translate)}}</span>
                                        </div>
                                        
                                        <div style="display: flex; justify-content: space-between; margin-top: 12px; padding-top: 12px; border-top: 2px solid #0c812c; font-weight: 700; font-size: 1.2em;">
                                            <span>{{'subscription.total_to_pay' | translate}}</span>
                                            <span style="color: #0c812c;">{{getFormattedPrice(getCurrentPrice(selectedPackage))}}</span>
                                        </div>
                                    </div>
                                    
                                    <div *ngIf="includeTablet" style="background: #fff3cd; border: 1px solid #ffc107; border-radius: 6px; padding: 12px; font-size: 0.9em; color: #856404;">
                                        <i class="fa fa-info-circle"></i>
                                        <strong>{{'common.important' | translate}} :</strong> {{'subscription.tablet_important_note' | translate: {price: getFormattedPrice(TABLET_PRICE.toString()), subscriptionPrice: getFormattedPrice(getSubscriptionPrice(selectedPackage)), period: selectedPeriod === 'MONTHLY' ? ('subscription.month' | translate) : ('subscription.year' | translate)} }}
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer" style="justify-content: center; padding: 16px 24px;">
                                <button class="btn btn-outline-secondary me-3" (click)="closeConfirmModal()" style="min-width: 120px;">
                                    {{'subscription.cancel' | translate}}
                                </button>
                                <button class="btn btn-success" [disabled]="processing" (click)="purchase()" style="min-width: 160px; background: #0c812c; border-color: #0c812c;">
                                    <span *ngIf="!processing"><i class="fa fa-lock"></i> {{'subscription.confirm_and_pay' | translate}}</span>
                                    <span *ngIf="processing">{{'common.loading' | translate}}...</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Mobile Money Payment Modal -->
                <div class="modal fade" [ngClass]="showMoMoForm ? 'show' : ''" style="display: block; background: rgba(51, 51, 51, .6);" *ngIf="showMoMoForm">
                    <div class="modal-dialog modal-dialog-centered modal-lg">
                        <div class="modal-content">
                            <div class="modal-header" style="background: #0c812c; color: #fff;">
                                <h5 class="modal-title" style="font-weight: bold;">eFarm.CM Mobile Money</h5>
                                <button class="btn-close btn-close-white" (click)="cancelMoMoPayment()"></button>
                            </div>
                            <div class="modal-body">
                                <div class="payment-message" style="padding: 0 2vw; margin: 2vh 0; margin-bottom: 2vh;">
                                    <div class="message" style="background-color: #f5f5f5; font-size: 1em; line-height: 1.5; padding: 2vh 2vw;">
                                        <strong>{{'common.to_continue' | translate}},</strong>
                                        <ol>
                                            <li>{{'payment.please_transfer' | translate}}
                                                <span style="font-weight: 900;">{{getFormattedPrice(getCurrentPrice(selectedPackage))}}</span><br>
                                                <ul>
                                                    <li>
                                                        Via MTN Mobile Money:<br>
                                                        {{'payment.to_number' | translate}} <span style="font-weight: 900;">681763523</span> ({{'common.name' | translate | lowercase}} = <span style="font-weight: 900;">EFARM CM</span>)<br>
                                                        <span>{{'payment.dial' | translate}} <strong>*126#</strong></span>
                                                    </li>
                                                    <li style="color: red; font-weight: bold;">---------------- {{'payment.or' | translate}} ----------------</li>
                                                    <li>
                                                        Via Orange Money:<br>
                                                        {{'payment.dial' | translate}} <strong style="font-weight: bold; font-size: 1.1em;">#150*47*764120*{{getCurrentPrice(selectedPackage)}}#</strong> ({{'common.name' | translate | lowercase}} = <span style="font-weight: 900;">EFARM CM</span>)
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>{{'payment.fill_transaction_id' | translate}}</li>
                                        </ol>
                                    </div>
                                </div>
                                <div style="padding: 0 2vw;">
                                    <div class="mb-3">
                                        <label style="display: block;">Buyer mobile money number</label>
                                        <input type="text" class="form-control" [(ngModel)]="moMoPhoneNumber" placeholder="Enter your mobile money number">
                                    </div>
                                    <div class="mb-3">
                                        <label style="display: block;">Transaction Id</label>
                                        <input type="text" class="form-control" [(ngModel)]="moMoTxRef" placeholder="Enter transaction reference">
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer" style="text-align:center; justify-content: center;">
                                <button class="btn btn-danger me-2" (click)="cancelMoMoPayment()">Close</button>
                                <button class="btn btn-success" [disabled]="processing" (click)="submitMoMoPayment()">
                                    <span *ngIf="!processing">Submit</span>
                                    <span *ngIf="processing">{{'common.loading' | translate}}...</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
            <div class="col-md-3">
                <app-sidebar [currentUser]="user"></app-sidebar>
            </div>
        </div>
    </div>
</div>
